import { stateColors } from '@/lib/constants'
import React from 'react'

interface StateIndicatorProps {
  state: string
}

const StateIndicator: React.FC<StateIndicatorProps> = ({ state }) => {
  if (state === 'Procesando') {
    return (
      <span className="inline-block w-3 h-3">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Procesando"
        >
          <circle
            cx="5"
            cy="5"
            r="4.5"
            stroke="#333333"
            strokeWidth="1"
            fill="none"
            strokeDasharray="2 2"
          />
        </svg>
      </span>
    )
  }
  const colorClass = stateColors[state] || 'bg-[#F2C94C]'

  return <span className={`inline-block w-3 h-3 rounded-full ${colorClass}`} />
}

export default StateIndicator
